import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { useLanguage } from '../LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-pattern"></div>
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon">
                <span>FM</span>
              </div>
              <div className="logo-text">
                <span className="logo-name">FUTURE MONEY</span>
              </div>
            </div>
            <p className="footer-description">
              {t('footer.description')}
            </p>
            <div className="footer-social">
              <a 
                href="https://www.linkedin.com/company/first-crypto-fund/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links-column">
            <h4 className="footer-title">{t('footer.quickLinks')}</h4>
            <ul className="footer-links">
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/about">{t('nav.about')}</Link></li>
              <li><Link to="/blog">{t('nav.blog')}</Link></li>
              <li><Link to="/contact">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Funds */}
          <div className="footer-links-column">
            <h4 className="footer-title">{t('footer.ourFunds')}</h4>
            <ul className="footer-links">
              <li><Link to="/first-crypto-fund">{t('nav.firstCryptoFund')}</Link></li>
              <li><a href="#hedge-fund">{t('footer.hedgeFund')}</a></li>
              <li><a href="#index-fund">{t('footer.bestCryptoIndex')}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-contact">
            <h4 className="footer-title">{t('footer.contact')}</h4>
            <ul className="contact-list">
              <li>
                <FaMapMarkerAlt />
                <span>Dunajska cesta 101, 1000 Ljubljana, Slovenia</span>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:katja.damij@tadadviser.com">katja.damij@tadadviser.com</a>
              </li>
              <li>
                <FaPhone />
                <a href="tel:+38641444001">+386 41 444 001</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p className="copyright">
              © {new Date().getFullYear()} FUTURE MONEY d.o.o. {t('footer.allRightsReserved')}
            </p>
            <div className="footer-legal">
              <Link to="/privacy">{t('footer.privacyPolicy')}</Link>
              <span className="separator">•</span>
              <Link to="/terms">{t('footer.termsOfService')}</Link>
              <span className="separator">•</span>
              <a href="https://noctrify.com/" target="_blank" rel="noopener noreferrer">{t('footer.designedBy')}</a>
            </div>
          </div>
          <p className="footer-disclaimer">
            {t('footer.disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
